import React from "react";
import { Card, Typography, Space } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import "./index.scss";

const { Title, Text } = Typography;

interface TicketCardProps {
  title: string;
  description: string;
  priority: string;
  status: string;
  attachment?: string;
}

const TicketCard: React.FC<TicketCardProps> = ({
  title,
  description,
  priority,
  status,
  attachment,
}) => {
  return (
    <Card
      className="ticket-card"
      styles={{
        body: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: "12px",
        },
      }}
    >
      <Space style={{ flex: 1, alignItems: "start" }}>
        <div className="ticket-card-icon">
          <img src="/assets/icons/ticket.png" alt="icon" width={24} />
        </div>
        <div className="grid">
          <Title level={5} className="ticket-card-title">
            {title}
          </Title>
          <Text color="gray" className="ticket-card-text">
            {description}
          </Text>
          <div className="ticket-card-meta">
            <Text strong className="ticket-card-label">
              Priority:
            </Text>{" "}
            {priority}{" "}
            <Text strong className="ticket-card-label">
              Status:
            </Text>{" "}
            {status}
          </div>
        </div>
      </Space>
      {attachment && (
        <PaperClipOutlined
          onClick={() =>
            window.open(attachment, "_blank", "noopener,noreferrer")
          }
          width={40}
          height={40}
          size={50}
          className="ticket-card-attachment"
        />
      )}
    </Card>
  );
};

export default TicketCard;
